import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import {
  faClipboard,
  faDownload,
  faHome,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getAllFieldIssueByDate,
  getFieldIssueDetails,
  getFieldIssueExcelDownload,
  getFieldIssuePdfDownload,
  getServiceFieldIssueExcel,
  getServiceFieldIssuePdf,
  getservicesfieldissueDispenserSerialNumber
} from "../../Service/AllServicesAPI";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Swal from "sweetalert2";
import Table from "react-bootstrap-table-next";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  const [show, setShow] = useState(false);
  const [entries, setEntries] = useState([]);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  //Pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getFieldIssueDetails(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Production Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {

            setEntries([]);
            setTotalCount();

          }
        })
        .catch((error) => console.error("Error", error));
      console.log("entries", entries);
    }
    // Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      await getAllFieldIssueByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Field Issue Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setTotalCount();
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  useEffect(() => {
    getAllField(); // Function call to get field List
    // eslint-disable-next-line
  }, []);

  const getAllField = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        await getFieldIssueDetails(currentPage, fkUserId, role, headers)
          .then((result) => {
            setisLoaded(false);
            console.log("Get Field Issue Result", result.data);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);

            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
            }
          })
          .catch((error) => {
            console.log("Get Field Issue Error (Service field job data is not present.)", error);
            // swal("Sorry", "Service field job data is not present.", "warning");
          });
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // const getAllFieldFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // Function declaration for setting toDate on "todate" Product change event
  // const getAllFieldToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };


  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getFieldByDate = async () => {
    try {
      setTimeout(async () => {
        // setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {
          await getAllFieldIssueByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              setisLoaded(false);
              console.log("Get Date wise Field Issue Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
                // setToDate("")
                // setFromDate("")

              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                swal(
                  "Sorry",
                  "Service field job data is not present for selected date.",
                  "warning"
                );
              }
            })
            .catch((error) => {
              console.log("Get Field Issue Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
  const getFieldIssueReportPdfDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        setisLoaded(true);
        await getFieldIssuePdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Something went wrong please check your internet",
          "error"
        );
      }
    } else {
      try {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        let result = await getServiceFieldIssuePdf(
          token,
          fileType,
          role,
          fkUserId
        );
        console.log("getServiceFieldIssue Pdf result :-", result);
        setisLoaded(false);
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log("getServiceFieldIssuePdf error :-", error);
      }
    }
  };

  const getFieldIssueReportExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getFieldIssueExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log("getFieldIssueWorkOrderExcelDownload error :-", error);
      }
    } else {
      try {
        await getServiceFieldIssueExcel();
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log("getServiceInstallationExcel error :-", error);
      }
    }
  };

  const sendImage = (cell) => {
    console.log("cell :-", cell);
    const newCell = cell.uploadDispenserPhoto?.split(",");
    console.log("newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src='data:image/${newCell[0]};base64,${newCell[1]}' />`
    );
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);

    getAllField();
  };

  const search = async (e) => {
    setSearchPerformed(true);
    console.log("e :-", e);
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return; // Exit early if the search input is empty
    }

    try {
      const role = sessionStorage.getItem("role");
      const pkFieldIssueHistoryId = sessionStorage.getItem("pkFieldIssueHistoryId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const result = await getservicesfieldissueDispenserSerialNumber(currentPage, searchDispenserSerialNumber, role, pkFieldIssueHistoryId, headers);
      // console.log("cheking data ", result?.content)
      // console.log("Searching for Dispenser Serial Number:", searchDispenserSerialNumber);

      if (result?.content?.length > 0) {
        const sortedData = result.content.sort((a, b) => b.pkFieldIssueHistoryId - a.pkFieldIssueHistoryId);
        setEntries(sortedData);
        setPageCount(1);
        setTotalCount(sortedData.length);

      } else {
        swal("No Data", "No records found for the given serial number", "info");

        setEntries([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };
  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Product list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Field job Wo Status",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
      },
    },
    
    {
      dataField: "workOrderSerialNo",
      text: "Field job Wo Sr No",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "fieldIssueDate",
      text: "Field Job Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "fieldIssueTime",
      text: "Field Job Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },

    {
      dataField: "oprationType",
      text: "Opration Type",
      editable: false,
      headerAlign: "left",
    },

    {
      dataField: "subOprationType",
      text: "SubOpration Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "modelName",
      text: "Dispenser Config",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        textAlign:'center'
      },
      width: 100,
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    {
      dataField: "siteAddress",
      text: "Site Address",
      editable: false,
      style: { textTransform: "capitalize",  },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.siteAddress}</span>
          )}
        </div>
      )

    },
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   editable: false,
    //   headerAlign: "left",
    //   width: 100,
    // },
    {
      dataField: "otp1",
      text: "OTP 1",
      editable: false,
      headerAlign: "left",
      width: 100,
      hidden: role === "service engineer" || role === "customer" || role === "dealer" ? true : false
    },
    {
      dataField: "otp2",
      text: "OTP 2",
      editable: false,
      headerAlign: "left",
      width: 100,
      hidden: role === "service engineer" || role === "customer" || role === "dealer" ? true : false
    },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
      width: 100,
    },
    
    {
      dataField: "uploadDispenserPhoto",
      text: "Dispenser Photo",
      editable: false,
      headerAlign: "left",
      // imageFormatter(cell) {
      //   return <img src={cell} />;
      // },
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendImage(cell)}
              disabled={!cell.uploadDispenserPhoto ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
      width: 100,
    },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );
  return (
    <>

      <Formik
        initialValues={{
          firstname: "",
          lastname: "",
          companyname: "",
          mobileno: "",
          selectdesignation: "",
          email: "",
          country: "",
          state: "",
          address: "",
          city: "",
          desc: "",
        }}
        onSubmit={async (values) => {
          console.log(JSON.stringify(values, null, 2));
        }}
      >
        {(formik) => {
          return (
            <>

              <>

                {role === "service engineer" ? (
                  <>
                    <Row>
                      <Col md={{ span: 2, order: 1 }} className="mb-3" xs={{ order: 3 }}>
                        <div className="form-group">
                          <label>From Date</label>
                          <DatePicker
                            selected={fromDate}
                            onChange={handleFromDateChange}
                            dateFormat="dd-MMM-yyyy"
                            maxDate={new Date()}
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                        <div className="form-group">
                          <label>To Date</label>
                          <DatePicker
                            selected={toDate}
                            onChange={handleToDateChange}
                            dateFormat="dd-MMM-yyyy"
                            minDate={fromDate}
                            maxDate={new Date()}
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 5 }}>
                        <button
                          className="btn btn-secondary mt-lg-4"
                          onClick={getFieldByDate}
                        >
                          <FontAwesomeIcon
                            icon={faSearch}
                            className="me-2"
                          />
                          <span>Search By Date</span>{" "}
                        </button>
                      </Col>
                      <Col md={{ span: 2, order: 4 }} className="mt-4" align="right" xs={{ order: 1 }}>
                        <Link
                          to="verification-fieldIssue-list"
                          className="btn btn-secondary"
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-2" />
                          <span>My Jobs </span>{" "}
                        </Link>
                      </Col>
                      {/* <Col md={{ span: 2, order: 5 }} className="mt-4" xs={{ order: 2 }}>
                        <div className="newadd" align="right">
                          <Link
                            to="ark-field-list"
                            className="btn btn-secondary"
                          >
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="me-2"
                            />
                            <span>ARK Verification List</span>{" "}
                          </Link>
                        </div>
                      </Col> */}
                    </Row>
                  </>
                ) : (
                  <>
                    <Row>
                      <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
                        <div className="form-group">
                          <label>From Date</label>
                          <DatePicker
                            selected={fromDate}
                            onChange={handleFromDateChange}
                            dateFormat="dd-MMM-yyyy"
                            maxDate={new Date()}
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                        <div className="form-group">
                          <label>To Date</label>
                          <DatePicker
                            selected={toDate}
                            onChange={handleToDateChange}
                            dateFormat="dd-MMM-yyyy"
                            minDate={fromDate}
                            maxDate={new Date()}
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            showYearDropdown
                            scrollableYearDropdown
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
                        <button
                          className="btn btn-secondary mt-lg-4"
                          onClick={getFieldByDate}
                        >
                          <FontAwesomeIcon
                            icon={faSearch}
                            className="me-2"
                          />
                          <span>Search By Date</span>{" "}
                        </button>
                      </Col>
                      {/* <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
                        <div className="newadd" align="right">
                          <Link
                            to="ark-field-list"
                            className="btn btn-secondary"
                          >
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="me-2"
                            />
                            <span>ARK Verification List</span>{" "}
                          </Link>
                        </div>
                      </Col> */}
                    </Row>
                  </>
                )}


                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange: (page) => {
                          handlePageChange(page);
                        },
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1 md-3 d-flex ">

                                  <input
                                    type="search"
                                    placeholder="Search by dispenser Sr No..."
                                    value={searchDispenserSerialNumber}
                                    onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                                    className="form-control-alternative form-control searchinput "
                                    style={{ marginRight: '10px' }}
                                  />

                                  <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : search}>
                                    <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                                    <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                                  </button>

                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getFieldIssueReportPdfDownload}
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      className="me-2"
                                    />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={
                                      getFieldIssueReportExcelDownload
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      className="me-2"
                                    />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            {isLoaded ? (
                              <div className="text-center bg-black text-white"> Please wait field job data is loading ... </div>
                            ) : (
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                filter={filterFactory()}
                                remote={{ pagination: true }}
                                headerClasses="header-class"
                                hover
                                striped
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    console.log(
                                      oldValue,
                                      newValue,
                                      row,
                                      column
                                    );
                                  },
                                })}
                                wrapperClasses="table-responsive"
                              />
                            )}
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                ></Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>

            </>
          );
        }}
      </Formik>

    </>
  );
};
